<template>
    <v-tooltip location="top" color="secondary">
        <template v-slot:activator="{ props }">
            <v-chip
                class="chip"
                :color="color"
                variant="flat"
                label
                v-bind="props"
            >
                <v-icon size="large">{{ icon }}</v-icon>
                &thinsp;
                <template v-if="loaded">{{ value }}</template>
            </v-chip>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script setup>
defineProps({
    value: { required: true },
    loaded: { type: Boolean, required: true },
    color: { type: String, required: true },
    icon: { type: String, required: true },
    tooltip: { type: String },
})
</script>

<style scoped>
.chip {
    margin-bottom: 12px;
    margin-right: 12px;
    min-width: 83px;
    justify-content: center;
}
</style>
